export const UNSET_PRODUCTS_FILTERS = "UNSET_PRODUCTS_FILTERS";
export const SET_PRODUCTS_FILTERS = "SET_PRODUCTS_FILTERS";
export const REPLACE_PRODUCTS_FILTERS = "REPLACE_PRODUCTS_FILTERS";
